const logger = process.server ? require('~/server/logger').errorLogger
  : (window.aegis ? window.aegis : null);
export function errorLogger(err) {
  logger && logger.error(JSON.stringify(err));
}
